import { render, staticRenderFns } from "./CustomerPrototypeItem.vue?vue&type=template&id=1f3d708e&scoped=true"
import script from "./CustomerPrototypeItem.vue?vue&type=script&lang=js"
export * from "./CustomerPrototypeItem.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrototypeItem.vue?vue&type=style&index=0&id=1f3d708e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d708e",
  null
  
)

export default component.exports